(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ajt-editorial"] && !Shopify.designMode) return;
  try {
    
(function(){
function initAJTFilm(){
 document.querySelectorAll('.ajt-video-hero').forEach(function(hero){
 if(hero.dataset.ready)return;
 hero.dataset.ready='true';
 const video=hero.querySelector('video'),button=hero.querySelector('.ajt-video-toggle');
 if(!video||!button)return;
 function frameBench(){hero.classList.toggle('ajt-bench-frame',video.currentTime<6);}
 video.addEventListener('timeupdate',frameBench);video.addEventListener('loadedmetadata',frameBench);frameBench();
 function update(){const label=video.paused?button.dataset.play:button.dataset.pause;button.textContent=label;button.setAttribute('aria-label',label);}
 video.addEventListener('play',update);video.addEventListener('pause',update);
 button.addEventListener('click',function(){if(video.paused)video.play().catch(update);else video.pause();});
 if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches&&!(navigator.connection&&navigator.connection.saveData)){video.play().catch(update);}
 update();
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initAJTFilm);else initAJTFilm();
document.addEventListener('shopify:section:load',initAJTFilm);
})();
(function(){
function setupAJTPerformanceFilms(){
 document.querySelectorAll('.ajt-performance-film').forEach(function(video){
  if(video.dataset.autoplayReady)return;
  video.dataset.autoplayReady='true';
  let visible=false,userPaused=false;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  video.muted=true;
  video.playsInline=true;
  const button=video.parentElement.querySelector('.ajt-performance-toggle');
  function updateButton(){if(!button)return;const label=video.paused?button.dataset.play:button.dataset.pause;button.textContent=label;button.setAttribute('aria-label',label);}
  if(button)button.addEventListener('click',function(){if(video.paused)video.play().catch(updateButton);else video.pause();});
  video.addEventListener('play',updateButton);video.addEventListener('pause',updateButton);updateButton();
  video.addEventListener('pause',function(){if(visible&&!video.ended)userPaused=true;});
  video.addEventListener('play',function(){userPaused=false;});
  const observer=new IntersectionObserver(function(entries){
   visible=entries[0].isIntersecting;
   if(!visible){video.pause();return;}
   if(!reduced.matches&&!userPaused)video.play().catch(function(){});
  },{threshold:0.2});
  observer.observe(video);
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setupAJTPerformanceFilms);else setupAJTPerformanceFilms();
document.addEventListener('shopify:section:load',setupAJTPerformanceFilms);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product"]) return;
  try {
    
function setupAJTPurchase(){
  const bar=document.querySelector('[data-ajt-mobile-purchase]');
  const options=document.getElementById('ajt-purchase-options');
  if(!bar||!options)return;
  const price=document.querySelector('.product-details .price .money:not(.original)');
  const update=()=>{if(price)bar.querySelector('[data-ajt-mobile-price]').textContent=price.textContent;};
  if(price)new MutationObserver(update).observe(price,{childList:true,subtree:true,characterData:true});
  new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting;},{threshold:0}).observe(options);
  update();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',setupAJTPurchase);}else{setupAJTPurchase();}

  } catch(e) { console.error(e); }
})();
})();
